import { render, staticRenderFns } from "./AddItemFull.vue?vue&type=template&id=e1639a20&"
import script from "./AddItemFull.vue?vue&type=script&lang=js&"
export * from "./AddItemFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports